
import Vue from 'vue'
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { Appraiser } from '../../shared/types/sinisters/appraisers';
import RenderTable from '../../core/components/Generics/Table/RenderTable.vue'
@Component({
    components: {
        RenderTable
    }
})

export default class SinisterAppraisersList extends Vue {
    @Prop({ default: () => [] }) appraisers!: Appraiser[];
    headers = [
        { text: 'Email', value: 'email' },
    ]


    mounted(){
        
    }

   
}

